// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media only screen and (max-width: 599px){.addon-links a{flex-grow:1}.addon-links a button{flex-grow:1}.addon-links a button img{display:none}}\n", ""]);
// Exports
module.exports = exports;
